exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-check .badge{\n      padding: 10px;\n      font-size: 100%;\n}\n", ""]);

// exports
